import { ModuleWithProviders, NgModule } from '@angular/core';

import { RtUIModule } from '@recruitee/user-interface';

import { TutorialTranslations } from './translations';
import { TutorialDialogNavComponent } from './tutorial-dialog-nav/tutorial-dialog-nav.component';
import { TutorialDialogComponent } from './tutorial-dialog.component';
import { AssetsProvider } from './tutorial-dialog.types';

@NgModule({
  imports: [RtUIModule],
  declarations: [TutorialDialogComponent, TutorialDialogNavComponent],
  exports: [TutorialDialogComponent, TutorialDialogNavComponent],
})
export class TutorialDialogModule {
  public static withProviders(
    translations: any,
    assetsProvider: (filePath: string) => string,
  ): ModuleWithProviders<TutorialDialogModule> {
    return {
      ngModule: TutorialDialogModule,
      providers: [
        { provide: TutorialTranslations, useValue: translations },
        { provide: AssetsProvider, useValue: assetsProvider },
      ],
    };
  }
}

export * from './tutorial-dialog-nav/tutorial-dialog-nav.component';
export * from './tutorial-dialog.component';
export * from './tutorial-dialog.service';
